import { render, staticRenderFns } from "./person-mobile-box.vue?vue&type=template&id=31a16b1c&lang=pug&"
import script from "./person-mobile-box.vue?vue&type=script&lang=js&"
export * from "./person-mobile-box.vue?vue&type=script&lang=js&"
import style0 from "./person-mobile-box.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports